<template>
    <type-wrapper class="type-F" padding>
        <!-- 标题 -->
        <type-grid row="11" margin v-if="showData.title">
            <type-text type="title" size="1">{{ showData.title }}</type-text>
        </type-grid>

        <!-- 横向循环滚动 -->
        <div class="scroll-container" v-if="pictureList.length">
            <!-- 动画行，animation-duration 由 prop speed 控制 -->
            <div
                class="logo-row"
                :style="{ animationDuration: speed + 's' }"
            >
                <!-- 第一套图片 -->
                <div
                    class="type-F-logo"
                    v-for="(item, index) in pictureList"
                    :key="'first-' + index"
                >
                    <type-image
                        mode="heightFix"
                        :src="item"
                        :alt="showData.alt"
                    />
                </div>

                <!-- 第二套图片（无缝衔接用）-->
                <div
                    class="type-F-logo"
                    v-for="(item, index) in pictureList"
                    :key="'second-' + index"
                >
                    <type-image
                        mode="heightFix"
                        :src="item"
                        :alt="showData.alt"
                    />
                </div>
            </div>
        </div>
    </type-wrapper>
</template>

<script>
import mixin from '../mixin.js'

export default {
    name: 'type-F',
    mixins: [mixin],
    props: {
        // 滚动一整轮的时间（秒）
        speed: {
            type: Number,
            default: 25
        }
    },
    computed: {
        pictureList () {
            return this.showData.picture || []
        }
    }
}
</script>

<style scoped lang="less">
/* 父容器隐藏滚动条 */
.scroll-container {
    width: 100%;
    overflow: hidden;
    padding: 10px 0;
}

/* 无缝动画行 */
@keyframes scrollLeft {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-50%); } /* 向左平移自身 50% 的宽度 */
}

.logo-row {
    display: inline-flex;
    flex-wrap: nowrap;
    animation-name: scrollLeft;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    /* animation-duration 在模板里动态设置 */
}

.type-F-logo {
    display: inline-flex;
    height: 200px;
    margin: 0 35px;
    flex-shrink: 0; /* 禁止被压缩，宽度固定 */
}
</style>